import React from 'react';
import { inject, observer } from "mobx-react";
import { AxlInput, AxlPanel, AxlReselect } from 'axl-reactjs-ui';
import { Box, IconButton, Checkbox, FormControlLabel } from '@material-ui/core';
import EditIcon from '@material-ui/icons/EditOutlined';
import styles, * as E from './styles';
import usstates from "../../../constants/usstates";
import timezoneOptions from "../../../constants/timezone";
import moment from "moment-timezone";
import AccountEditEmailModal from '../AccountEditEmailModal';

const timeZones = Object.keys(timezoneOptions).map( (tzName) => {
  return {label: tzName, value: timezoneOptions[tzName]};
} );

const stateSelectData = usstates.map((option) => ({
  label: option.name,
  value: option.abbreviation,
}))

@inject('clientStore')
@observer
class AccountInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      state: {label: '', value: ''},
      timezone: { label: moment.tz.guess(), value: moment.tz.guess() },
      open: false
    }
  }

  onSelectState = (selectState) => {
    const { clientStore } = this.props;
    const { settingsForm } = clientStore;
    settingsForm.setField('address.state', selectState ? selectState.value : '');
  }

  onSelectTimezone = (selectTimezone) => {
    const { clientStore } = this.props;
    const { settingsForm } = clientStore;
    settingsForm.setField('timezone', selectTimezone.value);
  };

  render() {
    const { clientStore } = this.props;
    const { settingsForm } = clientStore;
    const currentTimezone = timeZones.find( (tz) => tz.value === settingsForm.getField('timezone', moment.tz.guess()) );
    const currentState = stateSelectData.find( (usState) => usState.value === settingsForm.getField('address.state', '') );

    return <E.Container>
      <AxlPanel>
        <AxlPanel.Row style={styles.Row}>
          <AxlPanel.Col style={styles.Col}>
            <E.Label>{`Company`}</E.Label>
            <AxlInput value={settingsForm.getField('company', '')} onChange={settingsForm.handlerInput} name={`company`} type={`text`} error={settingsForm.getValidationError('company')} fluid />
          </AxlPanel.Col>
        </AxlPanel.Row>
        <AxlPanel.Row style={styles.Row}>
          <AxlPanel.Col style={styles.Col}>
            <E.Label>{`Name`}</E.Label>
            <AxlInput value={settingsForm.getField('name', '')} onChange={settingsForm.handlerInput} name={`name`} type={`text`} error={settingsForm.getValidationError('name')} fluid />
          </AxlPanel.Col>
          <AxlPanel.Col style={styles.Col}>
            <E.Label>{`Phone number`}</E.Label>
            <AxlInput value={settingsForm.getField('phone_number', '')} onChange={settingsForm.handlerInput} name={`phone_number`} type={`text`} error={settingsForm.getValidationError('phone_number')}  fluid />
          </AxlPanel.Col>
        </AxlPanel.Row>
        <AxlPanel.Row style={styles.Row}>
          <AxlPanel.Col style={styles.Col}>
            <E.Label>{`Email`} </E.Label>
            <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
              <div style={{ flex: 1 }}>
                <AxlInput
                  value={settingsForm.getField('email', '')}
                  name={`email`}
                  type={`text`}
                  fluid
                  disabled={true}
                />
              </div>
              <IconButton variant="link" color="primary" size="small" onClick={() => this.setState({ open: true })}><EditIcon /></IconButton>
            </Box>
            
          </AxlPanel.Col>
          <AxlPanel.Col style={styles.Col}>
            <E.Label>{`Support Email`}</E.Label>
            <AxlInput value={settingsForm.getField('support_email', '')} onChange={settingsForm.handlerInput} name={`support_email`} type={`text`} error={settingsForm.getValidationError('support_email')}  fluid />
          </AxlPanel.Col>
        </AxlPanel.Row>
        <AxlPanel.Row style={styles.Row}>
          <AxlPanel.Col style={styles.Col}>
            <E.Label>{`Facebook ID`}</E.Label>
            <AxlInput value={settingsForm.getField('facebook_id', '')} onChange={settingsForm.handlerInput} name={`facebook_id`} type={`text`} error={settingsForm.getValidationError('facebook_id')} fluid />
          </AxlPanel.Col>
          <AxlPanel.Col style={styles.Col}>
            <E.Label>{`Twitter ID`}</E.Label>
            <AxlInput value={settingsForm.getField('twitter_id', '')} onChange={settingsForm.handlerInput} name={`twitter_id`} type={`text`} error={settingsForm.getValidationError('twitter_id')} fluid />
          </AxlPanel.Col>
        </AxlPanel.Row>
        <AxlPanel.Row style={styles.Row}>
          <AxlPanel.Col style={styles.Col}>
            <E.Label>{`Address Line 1 (house or building number and street name)`}</E.Label>
            <AxlInput value={settingsForm.getField('address.street', '')} onChange={settingsForm.handlerInput} name={`address.street`} type={`text`} error={settingsForm.getValidationError('address.street')} fluid />
          </AxlPanel.Col>
        </AxlPanel.Row>
        <AxlPanel.Row style={styles.Row}>
          <AxlPanel.Col style={styles.Col}>
            <E.Label>{`Address Line 2 (unit or apartment information)`}</E.Label>
            <AxlInput value={settingsForm.getField('address.street2', '')} onChange={settingsForm.handlerInput} name={`address.street2`} type={`text`} error={settingsForm.getValidationError('address.street2')} fluid />
          </AxlPanel.Col>
        </AxlPanel.Row>
        <AxlPanel.Row style={styles.Row}>
          <AxlPanel.Col style={styles.Col}>
            <E.Label>{`City`}</E.Label>
            <AxlInput value={settingsForm.getField('address.city', '')} onChange={settingsForm.handlerInput} name={`address.city`} type={`text`} error={settingsForm.getValidationError('address.city')} fluid />
          </AxlPanel.Col>
          <AxlPanel.Col style={styles.Col}>
            <E.Label>{`State`}</E.Label>
            <AxlReselect value={currentState} onChange={this.onSelectState} name={`address.state`} placeholder={'Select State'} theme={`main`} options={stateSelectData} error={settingsForm.getValidationError('address.state')} isClearable/>
          </AxlPanel.Col>
          <AxlPanel.Col style={styles.Col}>
            <E.Label>{`Zipcode`}</E.Label>
            <AxlInput value={settingsForm.getField('address.zipcode', '')} onChange={settingsForm.handlerInput} name={`address.zipcode`} type={`text`} error={settingsForm.getValidationError('address.zipcode')} fluid />
          </AxlPanel.Col>
        </AxlPanel.Row>
        <AxlPanel.Row style={styles.Row}>
          <AxlPanel.Col style={styles.Col}>
            <E.Label>{`Timezone`}</E.Label>
            <AxlReselect value={currentTimezone} placeholder="Timezone" onChange={this.onSelectTimezone} options={timeZones} error={settingsForm.getValidationError('timezone')} theme={`main`} /></AxlPanel.Col>
        </AxlPanel.Row>
        <AxlPanel.Row style={styles.Row} align={`flex-start`} col>
          <AxlPanel.Col style={styles.Col}>
            <FormControlLabel
              control={<Checkbox readOnly={true} checked={settingsForm.getField('insurance_enabled', false)} name={`insurance_enabled`} color="primary" />} label={`Opt-in for Insurance (address is mandatory when opted-in)`} />
          </AxlPanel.Col>
        </AxlPanel.Row>
      </AxlPanel>
      <AccountEditEmailModal
        open={this.state.open}
        onClose={() => this.setState({ open: false })}
        onOk={(newEmail) => {
          // Update the email in the form
          settingsForm.setField('email', newEmail);
          this.setState({ open: false });
        }}
        currentEmail={settingsForm.getField('email', '')}
      />
    </E.Container>
  }
}

export default AccountInfo;
